export default {
  name: 'marking--labelTemplate',
  apiService: 'shoes',
  apiPath: '/admin/label_template',
};